import { createForm } from 'shared-ui/lib/customs/form/FormGenerator';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import { userInputs } from '../../inputs/user.inputs';

const form: FormInput[] = [userInputs.name, userInputs.email, userInputs.level];

export const inviteUserForm = createForm(form);

export type InviteUserFormBody = {
  email: string;
  name: string;
  level: string;
};
